var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourseBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 438,
    viewBox: "0 0 512 438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-total_marks_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 438
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "total_marks_1",
    "data-name": "total marks \\u2013 1",
    clipPath: "url(#clip-total_marks_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M87.386,139.843l2.483-4.089c20.962-34.465,58.775-55.248,98.622-52.731a102.861,102.861,0,0,1,15.267,2.089c36.252,7.763,67.8,35.173,80.883,70.29,7.7,20.648,9.841,44.418,24.433,60.808,19,21.344,51.238,22.007,79.58,21.119s60.663-.135,79.513,21.288c11.841,13.413,15.593,32.477,14.6,50.44-2.528,47.553-35.656,90.072-77.794,111.215s-91.713,23.029-137.85,13.739c-64.594-13.02-126.043-48.8-162.969-104.036S57.875,199.472,87.386,139.843Z",
    transform: "translate(-27.667 -63.494)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M139.451,115.94a1.235,1.235,0,0,0-.1.3l-.247.9a12.989,12.989,0,0,1-.461,1.46c-.2.562-.416,1.224-.741,1.932l-.494,1.123-.64,1.213a11.816,11.816,0,0,1-.741,1.292c-.281.427-.528.9-.865,1.348A29.084,29.084,0,0,1,122.432,135.9a27.35,27.35,0,0,1-4.842,1.517,46.6,46.6,0,0,1-5.336.741c-3.673.359-7.65.562-11.458,2.09a27.872,27.872,0,0,0-9.976,7.47,36.263,36.263,0,0,0-6.875,10.425,19.347,19.347,0,0,0-1.371,5.819,21.839,21.839,0,0,0,.359,5.707,68.921,68.921,0,0,0,3.033,10.11,47.665,47.665,0,0,1,2.4,8.807,18.3,18.3,0,0,1-.281,7.459,13.9,13.9,0,0,1-2.438,5.078,10.224,10.224,0,0,1-2.629,2.426c-.685.438-1.123.607-1.123.629a7.253,7.253,0,0,0,1.123-.562,10.109,10.109,0,0,0,2.7-2.4,13.748,13.748,0,0,0,2.528-5.111,18.514,18.514,0,0,0,.348-7.56,48.669,48.669,0,0,0-2.382-8.863,70.445,70.445,0,0,1-2.988-10.11,22.3,22.3,0,0,1-.337-5.617,18.648,18.648,0,0,1,1.359-5.7,36.175,36.175,0,0,1,6.808-10.324,27.523,27.523,0,0,1,9.841-7.369c3.718-1.517,7.661-1.719,11.346-2.09a50.619,50.619,0,0,0,5.37-.764,27.715,27.715,0,0,0,4.943-1.483,28.961,28.961,0,0,0,12.773-10.571c.337-.449.6-.921.865-1.359a14.088,14.088,0,0,0,.73-1.314l.629-1.213.483-1.123a17.977,17.977,0,0,0,.719-1.955,12.356,12.356,0,0,0,.416-1.472c.09-.393.169-.7.213-.91A2.506,2.506,0,0,0,139.451,115.94Z",
    transform: "translate(302.33 -59.408)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M162.134,105.34l-.247.225-.7.674c-.3.3-.64.708-1.123,1.123a8.381,8.381,0,0,0-1.3,1.708,24.128,24.128,0,0,0-2.775,5.212,25.029,25.029,0,0,0-1.7,7.628,26.127,26.127,0,0,0,.168,4.55,32.759,32.759,0,0,0,1.056,4.831c.932,3.28,2.247,6.65,3.235,10.346a26.313,26.313,0,0,1,.82,5.763,24.585,24.585,0,0,1-.618,6.033,28.085,28.085,0,0,1-5.549,11.459,31.88,31.88,0,0,1-9.852,8.043,38.274,38.274,0,0,1-11.234,3.909c-3.752.7-7.392.876-10.762,1.393a27.154,27.154,0,0,0-9.054,2.741,20.8,20.8,0,0,0-10.11,13.672c-.067.416-.112.73-.157.966a2.34,2.34,0,0,0,0,.326,1.065,1.065,0,0,1,.079-.326,7.991,7.991,0,0,0,.191-.944,22.571,22.571,0,0,1,1.123-3.527,21.221,21.221,0,0,1,3.067-4.977,20.219,20.219,0,0,1,5.954-4.9,26.962,26.962,0,0,1,8.987-2.662c3.37-.505,7-.674,10.784-1.359a39.109,39.109,0,0,0,11.346-3.932,32.287,32.287,0,0,0,9.976-8.133,28.78,28.78,0,0,0,5.617-11.56,25.912,25.912,0,0,0,.607-6.122,26.737,26.737,0,0,0-.831-5.842c-.955-3.73-2.337-7.1-3.28-10.358a32.463,32.463,0,0,1-1.123-4.774,24.641,24.641,0,0,1-.191-4.493,25.231,25.231,0,0,1,4.325-12.762c.438-.685.9-1.225,1.269-1.73a6.565,6.565,0,0,1,1.033-1.123l.663-.708A2.639,2.639,0,0,0,162.134,105.34Z",
    transform: "translate(256.808 -60.715)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M129.05,177a6.044,6.044,0,0,0,.876.8c.584.505,1.449,1.2,2.539,2.033a101.313,101.313,0,0,0,8.807,6.089,103.714,103.714,0,0,0,9.4,5.134c1.236.6,2.247,1.056,2.943,1.348a5.622,5.622,0,0,0,1.123.427,8.36,8.36,0,0,0-1.045-.562l-2.9-1.449c-2.438-1.236-5.763-3.033-9.313-5.224s-6.65-4.359-8.852-5.976l-2.6-1.932A7.662,7.662,0,0,0,129.05,177Z",
    transform: "translate(234.071 -51.873)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M126.87,172.8a5.135,5.135,0,0,0,.888.528l2.449,1.326c2.067,1.123,4.9,2.719,7.965,4.595s5.763,3.7,7.7,5.033l2.247,1.6a7.011,7.011,0,0,0,.865.55,5.462,5.462,0,0,0-.775-.674c-.517-.416-1.281-.989-2.247-1.685-1.9-1.4-4.595-3.246-7.661-5.134s-5.931-3.449-8.032-4.494c-1.056-.539-1.91-.955-2.516-1.224a5.993,5.993,0,0,0-.876-.416Z",
    transform: "translate(242.284 -52.393)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M127.69,171.18a12.383,12.383,0,0,0,1.741,1.269c1.124.73,2.64,1.719,4.37,2.763s3.314,1.932,4.494,2.561a12.235,12.235,0,0,0,1.932.932,12.884,12.884,0,0,0-1.8-1.123L134,174.932l-4.426-2.662A11.877,11.877,0,0,0,127.69,171.18Z",
    transform: "translate(250.114 -52.592)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M123.52,162.68a7.12,7.12,0,0,0,1.314.955l3.247,2.179,3.224,2.247a7.448,7.448,0,0,0,1.37.865,5.978,5.978,0,0,0-1.213-1.123c-.786-.629-1.9-1.449-3.168-2.314a39.524,39.524,0,0,0-3.37-2.089,6.164,6.164,0,0,0-1.4-.719Z",
    transform: "translate(262.35 -53.641)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M116.77,155.1c0,.056.955.573,2.494,1.46s3.64,2.179,5.853,3.73,4.145,3.1,5.5,4.246a27.85,27.85,0,0,0,2.247,1.842,4.058,4.058,0,0,0-.517-.584c-.348-.36-.876-.854-1.539-1.46a57.236,57.236,0,0,0-11.4-8.01c-.786-.416-1.438-.73-1.887-.944A3.049,3.049,0,0,0,116.77,155.1Z",
    transform: "translate(269.74 -54.576)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M111.511,149.22c-.056.09,3.887,2.932,8.807,6.37s8.987,6.134,8.987,6.055-3.876-2.943-8.8-6.37S111.578,149.13,111.511,149.22Z",
    transform: "translate(279.213 -55.301)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M107.09,142.59a4.411,4.411,0,0,0,.764.562c.562.382,1.269.865,2.123,1.427,1.8,1.2,4.269,2.887,6.954,4.8s5.066,3.707,6.74,5.01l2.045,1.55a4.478,4.478,0,0,0,.775.528,4.082,4.082,0,0,0-.685-.652c-.449-.393-1.123-.955-1.966-1.64-1.685-1.359-4.044-3.19-6.74-5.1s-5.19-3.572-7.021-4.718c-.921-.573-1.674-1.022-2.247-1.326A4.2,4.2,0,0,0,107.09,142.59Z",
    transform: "translate(286.992 -56.119)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M104.7,138.92c-.067.079,3.28,2.505,7.459,5.415s7.628,5.179,7.7,5.1-3.292-2.516-7.471-5.415S104.756,138.83,104.7,138.92Z",
    transform: "translate(296.313 -56.572)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M104.67,135.22a31.81,31.81,0,0,0,3.842,3.314,34.456,34.456,0,0,0,4.078,3.022,34.328,34.328,0,0,0-3.842-3.37,34.447,34.447,0,0,0-4.078-2.966Z",
    transform: "translate(303.611 -57.029)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M96.52,125.93a12.472,12.472,0,0,0,1.64,1.517c1.045.887,2.528,2.089,4.213,3.37s3.247,2.337,4.4,3.089a11.355,11.355,0,0,0,1.921,1.123,14.6,14.6,0,0,0-1.775-1.359c-1.123-.809-2.651-1.921-4.325-3.168s-3.179-2.415-4.269-3.258A13.962,13.962,0,0,0,96.52,125.93Z",
    transform: "translate(316.659 -58.176)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M90.78,119.61a4.5,4.5,0,0,0,.753.584c.483.359,1.213.854,2.112,1.449,1.809,1.2,4.348,2.808,7.212,4.494s5.527,3.056,7.47,4.022c.966.483,1.764.865,2.314,1.123a4.186,4.186,0,0,0,.876.359,5.077,5.077,0,0,0-.809-.483l-2.247-1.224c-1.91-1.022-4.493-2.46-7.4-4.123s-5.415-3.213-7.257-4.359L91.623,120.1A4.255,4.255,0,0,0,90.78,119.61Z",
    transform: "translate(320.287 -58.955)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M86.54,112.86a6.15,6.15,0,0,0,.82.618c.539.382,1.326.921,2.314,1.584,1.966,1.3,4.707,3.078,7.774,4.977s5.864,3.561,7.864,4.729c1.022.584,1.854,1.056,2.438,1.37a6.492,6.492,0,0,0,.921.449,5.427,5.427,0,0,0-.843-.584l-2.382-1.472-7.864-4.819-7.864-4.876-2.382-1.483A4.955,4.955,0,0,0,86.54,112.86Z",
    transform: "translate(327.897 -59.787)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M361.466,313.281c.056.056.888-.775,2.505-2.157.809-.685,1.808-1.517,3.022-2.4a33.961,33.961,0,0,1,4.314-2.7A18.391,18.391,0,0,1,374,304.9a8.9,8.9,0,0,1,3.033-.539,3.27,3.27,0,0,1,1.472.348,2.245,2.245,0,0,1,1.011,1.067,3.705,3.705,0,0,1,.3,1.6,7.966,7.966,0,0,1-.225,1.753,16.683,16.683,0,0,1-1.3,3.516,32.466,32.466,0,0,1-1.988,3.449,47.842,47.842,0,0,1-11.638,11.986,29.873,29.873,0,0,1-3.37,2.089,16.44,16.44,0,0,1-3.483,1.415,7.909,7.909,0,0,1-1.741.281,3.724,3.724,0,0,1-1.6-.258,2.248,2.248,0,0,1-1.123-.977,3.374,3.374,0,0,1-.393-1.46,8.735,8.735,0,0,1,.449-3.056,19.756,19.756,0,0,1,1.123-2.73,34.989,34.989,0,0,1,2.573-4.393c.854-1.236,1.64-2.247,2.314-3.089,1.326-1.651,2.135-2.516,2.078-2.573s-.247.168-.663.562-.989.977-1.7,1.775a38.612,38.612,0,0,0-2.46,3.022,32.633,32.633,0,0,0-2.741,4.4,22.2,22.2,0,0,0-1.18,2.808,9.545,9.545,0,0,0-.528,3.37,3.991,3.991,0,0,0,.472,1.809,3.022,3.022,0,0,0,1.461,1.337,4.557,4.557,0,0,0,1.955.348,8.713,8.713,0,0,0,1.943-.281,17.627,17.627,0,0,0,3.673-1.46,30.606,30.606,0,0,0,3.5-2.247,47.335,47.335,0,0,0,11.874-12.245,30.3,30.3,0,0,0,2.033-3.55,17.758,17.758,0,0,0,1.337-3.718,8.14,8.14,0,0,0,.225-1.943,4.315,4.315,0,0,0-.4-1.943,3.044,3.044,0,0,0-1.382-1.427,4.1,4.1,0,0,0-1.82-.416,9.492,9.492,0,0,0-3.3.629,20.194,20.194,0,0,0-2.764,1.27,32.225,32.225,0,0,0-4.314,2.865c-1.2.944-2.179,1.809-2.955,2.55s-1.348,1.337-1.719,1.753A4.82,4.82,0,0,0,361.466,313.281Z",
    transform: "translate(-258.52 -81.597)",
    fill: "#455a64",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M373.263,316.3c-.067,0,.258,1.123.685,3.123.214,1.011.449,2.247.641,3.685a31.448,31.448,0,0,1,.27,4.909,17.69,17.69,0,0,1-.292,2.82,8.4,8.4,0,0,1-1,2.808,3.372,3.372,0,0,1-1.011,1.067,2.379,2.379,0,0,1-1.382.382,3.707,3.707,0,0,1-1.539-.382,7.122,7.122,0,0,1-1.416-.955,16.06,16.06,0,0,1-2.46-2.674,28.486,28.486,0,0,1-2.056-3.247,44.574,44.574,0,0,1-4.887-15.39,29.66,29.66,0,0,1-.191-3.831,16.249,16.249,0,0,1,.46-3.606,8.208,8.208,0,0,1,.607-1.6,3.641,3.641,0,0,1,.988-1.213,2.336,2.336,0,0,1,1.348-.494,3.371,3.371,0,0,1,1.438.292,8.5,8.5,0,0,1,2.438,1.708,18.2,18.2,0,0,1,1.865,2.146A30.761,30.761,0,0,1,370.421,310c.674,1.281,1.191,2.426,1.6,3.37.809,1.9,1.18,2.977,1.247,2.954a2.5,2.5,0,0,0-.168-.82c-.146-.528-.382-1.292-.73-2.247s-.831-2.146-1.472-3.471a29.861,29.861,0,0,0-2.55-4.325,16.594,16.594,0,0,0-1.9-2.247,8.99,8.99,0,0,0-2.64-1.921,4.166,4.166,0,0,0-1.764-.371,3.177,3.177,0,0,0-1.82.629,4.553,4.553,0,0,0-1.236,1.471,8.3,8.3,0,0,0-.7,1.775,16.462,16.462,0,0,0-.517,3.8,27.732,27.732,0,0,0,.169,3.966,43.807,43.807,0,0,0,5,15.727,28.185,28.185,0,0,0,2.146,3.37,16.328,16.328,0,0,0,2.618,2.8,8.231,8.231,0,0,0,1.584,1.045,4.429,4.429,0,0,0,1.865.494,3.212,3.212,0,0,0,1.842-.528,4.315,4.315,0,0,0,1.236-1.326,9.063,9.063,0,0,0,1.045-3.089,16.858,16.858,0,0,0,.247-2.932,28.808,28.808,0,0,0-.416-5.01,36.726,36.726,0,0,0-.8-3.685c-.27-1-.528-1.764-.708-2.247A2.573,2.573,0,0,0,373.263,316.3Z",
    transform: "translate(-259.543 -81.919)",
    fill: "#455a64",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M368.137,310.171c0,.079,1.124.371,3.022,1.067.966.348,2.134.8,3.471,1.393a31.23,31.23,0,0,1,4.314,2.359,16.48,16.48,0,0,1,2.247,1.73,8.114,8.114,0,0,1,1.853,2.325,3.37,3.37,0,0,1,.382,1.415,2.348,2.348,0,0,1-.416,1.382,3.474,3.474,0,0,1-1.124,1.056,7.8,7.8,0,0,1-1.55.708,16.5,16.5,0,0,1-3.573.674,29.06,29.06,0,0,1-3.842,0,42.423,42.423,0,0,1-8.01-1.247,43.028,43.028,0,0,1-7.65-2.7,30.011,30.011,0,0,1-3.37-1.854,15.386,15.386,0,0,1-2.82-2.247,6.9,6.9,0,0,1-1.033-1.359,3.567,3.567,0,0,1-.517-1.472,2.406,2.406,0,0,1,.281-1.4,3.56,3.56,0,0,1,1.011-1.123,8.322,8.322,0,0,1,2.741-1.124,17.994,17.994,0,0,1,2.8-.46,31.426,31.426,0,0,1,4.921,0c1.449.112,2.7.27,3.718.416,2.022.315,3.135.573,3.157.494a2.735,2.735,0,0,0-.786-.281c-.517-.157-1.292-.359-2.314-.573a37.515,37.515,0,0,0-3.73-.573,30.147,30.147,0,0,0-5.022-.112,17.181,17.181,0,0,0-2.909.427,8.7,8.7,0,0,0-3.022,1.236,4.078,4.078,0,0,0-1.247,1.3,3.111,3.111,0,0,0-.416,1.876,4.3,4.3,0,0,0,.6,1.831,8.332,8.332,0,0,0,1.123,1.517,16.459,16.459,0,0,0,2.966,2.449,29.488,29.488,0,0,0,3.46,1.943,43.178,43.178,0,0,0,7.864,2.775,42.055,42.055,0,0,0,8.19,1.247,27.355,27.355,0,0,0,3.965-.067,16.218,16.218,0,0,0,3.763-.753,8.068,8.068,0,0,0,1.73-.8,4.606,4.606,0,0,0,1.393-1.326,3.19,3.19,0,0,0,.517-1.842,4.111,4.111,0,0,0-.483-1.752,8.992,8.992,0,0,0-2.067-2.516,18.371,18.371,0,0,0-2.37-1.752,30.127,30.127,0,0,0-4.493-2.247,37.234,37.234,0,0,0-3.561-1.258c-.989-.292-1.775-.483-2.3-.6A2.717,2.717,0,0,0,368.137,310.171Z",
    transform: "translate(-258.103 -80.97)",
    fill: "#455a64",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M362.9,316.02a3.011,3.011,0,1,0,3.651-2.191A3.01,3.01,0,0,0,362.9,316.02Z",
    transform: "translate(-258.526 -80.337)",
    fill: "#455a64",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    cx: 21.569,
    cy: 21.569,
    rx: 21.569,
    ry: 21.569,
    transform: "matrix(-0.161, -0.987, 0.987, -0.161, 189.606, 61.293)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    transform: "translate(210.252 39.76)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M281.74,104.526a3.516,3.516,0,1,0,3.516-3.516A3.516,3.516,0,0,0,281.74,104.526Z",
    transform: "translate(-281.74 -101.01)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    transform: "translate(215.194 31.076)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M279.96,95.325A2.045,2.045,0,1,0,282,93.28,2.044,2.044,0,0,0,279.96,95.325Z",
    transform: "translate(-279.96 -93.28)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M316.665,106.539c-.1.371,18.457,18.176,13.672,21.973s-24.905-5.943-42.059-19.794-32.814-30.679-28.523-35.128,25.714,8.729,25.714,8.729l-2.606,1.629s-12.953-8.313-17.053-5.089,7.583,15.84,24.074,27.882,32.432,20.49,34.9,17.188-9.2-14.3-9.2-14.3Z",
    transform: "translate(-88.339 -64.746)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413",
    transform: "translate(170.699 7.928)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M316.665,106.539c-.1.371,18.457,18.176,13.672,21.973s-24.905-5.943-42.059-19.794-32.814-30.679-28.523-35.128,25.714,8.729,25.714,8.729l-2.606,1.629s-12.953-8.313-17.053-5.089,7.583,15.84,24.074,27.882,32.432,20.49,34.9,17.188-9.2-14.3-9.2-14.3Z",
    transform: "translate(-259.038 -72.673)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    transform: "translate(219.226 21.334)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M272.8,84.622c-.168.213,1.292,1.449,2.943,3.943a19.861,19.861,0,0,1,.438,21.816c-1.562,2.55-2.966,3.853-2.786,4.055s1.842-.854,3.763-3.37a18.994,18.994,0,0,0-.461-23.186C274.719,85.408,272.944,84.476,272.8,84.622Z",
    transform: "translate(-272.785 -84.607)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M344.625,116.413A12.526,12.526,0,1,0,332.4,129.231,12.526,12.526,0,0,0,344.625,116.413Z",
    transform: "translate(-169.85 -60.857)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415",
    transform: "translate(154.083 49.063)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M338.448,111.29a2.033,2.033,0,1,0-.559,1.458A2.045,2.045,0,0,0,338.448,111.29Z",
    transform: "translate(-334.359 -109.291)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416",
    transform: "translate(151.701 54.67)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M340.381,115.437a1.191,1.191,0,1,0-1.123,1.224A1.191,1.191,0,0,0,340.381,115.437Z",
    transform: "translate(-338 -114.282)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    transform: "translate(155.251 59.477)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M336.617,118.56a.449.449,0,0,0-.438.449.438.438,0,0,0,.449.427.427.427,0,0,0,.427-.449A.438.438,0,0,0,336.617,118.56Z",
    transform: "translate(-336.179 -118.56)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M365.641,206.03c.112,0,.191-15.862.191-35.42s-.079-35.42-.191-35.42-.191,15.851-.191,35.42S365.54,206.03,365.641,206.03Z",
    transform: "translate(-242.586 -57.033)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M363.83,136.237a31.775,31.775,0,0,0,2.4-4.111H365.9v.09a34.265,34.265,0,0,0,2.056,4.415,29.6,29.6,0,0,0-1.708-4.561v-.09l-.157-.359-.18.337a29.645,29.645,0,0,0-2.078,4.28Z",
    transform: "translate(-242.887 -57.473)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M363.816,128.007c.067.079.651-.3,1.123-1.011s.584-1.393.483-1.415-.371.562-.8,1.213S363.749,127.928,363.816,128.007Z",
    transform: "translate(-240.368 -58.219)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M366.212,130.109a13.185,13.185,0,0,0-.9-2.528,12.648,12.648,0,0,0-1.033-2.471,7.483,7.483,0,0,0,.685,2.606A7.382,7.382,0,0,0,366.212,130.109Z",
    transform: "translate(-241.652 -58.275)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M362.166,143.976a21.09,21.09,0,0,1-.651-2.179,21.9,21.9,0,0,1,0-2.247,3.236,3.236,0,0,0-.326,2.337,3.2,3.2,0,0,0,.977,2.089Z",
    transform: "translate(-234.033 -56.494)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M360.134,141.044a.7.7,0,0,0,.539.416,1.056,1.056,0,0,0,.775-.135,1.056,1.056,0,0,0-.674-1.955c-.461,0-.618.337-.573.36a2.178,2.178,0,0,1,.584-.09.752.752,0,0,1,.764.809.775.775,0,0,1-.843.741C360.358,141.2,360.179,141,360.134,141.044Z",
    transform: "translate(-232.697 -56.518)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M360.71,193.791c0,.1,13.57.191,30.331.191s30.331-.09,30.331-.191-13.559-.191-30.331-.191S360.71,193.69,360.71,193.791Z",
    transform: "translate(-292.802 -49.826)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M410.9,193.91a9.159,9.159,0,0,0,2.539-.786A9.391,9.391,0,0,0,415.8,192a8.85,8.85,0,0,0-2.494.8A9.108,9.108,0,0,0,410.9,193.91Z",
    transform: "translate(-343.609 -50.023)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M412.17,193.9a12.257,12.257,0,0,0,4.134,1.449,6.979,6.979,0,0,0-2.011-.9A6.338,6.338,0,0,0,412.17,193.9Z",
    transform: "translate(-345.542 -49.789)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M362.211,195.48a1.864,1.864,0,0,0-.786,1.258,2.674,2.674,0,0,0,.123,1.651,1.912,1.912,0,0,0,.607.82,1.033,1.033,0,0,0,1.123,0,2.168,2.168,0,0,0,.876-1.842,1.921,1.921,0,0,0-.674-1.517,1.449,1.449,0,0,0-1.067-.348c-.27,0-.393.124-.382.135a3.508,3.508,0,0,0,.382,0,1.472,1.472,0,0,1,.888.4,1.674,1.674,0,0,1,.506,1.3,1.887,1.887,0,0,1-.719,1.528.685.685,0,0,1-.741,0,1.6,1.6,0,0,1-.506-.652,2.638,2.638,0,0,1-.18-1.46A4.582,4.582,0,0,1,362.211,195.48Z",
    transform: "translate(-236.303 -49.594)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M406.464,196.206s-.214-.124-.506.124a.753.753,0,0,0-.258.607,1.291,1.291,0,0,0,.359.775c.427.472,1.213.652,1.573,1.225a1.011,1.011,0,0,1,0,.977.955.955,0,0,1-.921.461.91.91,0,0,1-.8-.652,1,1,0,0,1,.191-.966,2.758,2.758,0,0,1,.809-.64,1.2,1.2,0,0,0,.719-.741,1,1,0,0,0-.191-.842,1.256,1.256,0,0,0-.505-.382c-.326-.112-.517-.09-.528-.067a1.343,1.343,0,0,1,.46.2,1.123,1.123,0,0,1,.4.371.764.764,0,0,1,.1.651c-.112.483-1.011.551-1.539,1.236a1.371,1.371,0,0,0-.27,1.3,1.292,1.292,0,0,0,1.123.9,1.325,1.325,0,0,0,1.281-.64,1.371,1.371,0,0,0,0-1.348,2.246,2.246,0,0,0-.9-.741,4.02,4.02,0,0,1-.775-.494,1.044,1.044,0,0,1-.337-.607.651.651,0,0,1,.146-.483C406.239,196.206,406.464,196.239,406.464,196.206Z",
    transform: "translate(-329.894 -49.521)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M406.881,195.3a7.426,7.426,0,0,0,0-3.37A7.426,7.426,0,0,0,406.881,195.3Z",
    transform: "translate(-330.154 -50.031)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M418.957,194.162a2.73,2.73,0,0,0,1.033.157l1.124.067a.4.4,0,0,0,.258,0,.314.314,0,0,0,.135-.337.7.7,0,0,0-.236-.36l-.494-.517a1.639,1.639,0,0,1-.618-1.067.685.685,0,0,1,.472-.7,1.122,1.122,0,0,1,.662.124c.169.067.258.112.281.09s-.056-.1-.2-.213a1.124,1.124,0,0,0-.786-.27.966.966,0,0,0-.775.977,1.931,1.931,0,0,0,.674,1.314l.517.506c.09.079.157.157.157.191h-1.191A3.031,3.031,0,0,0,418.957,194.162Z",
    transform: "translate(-358.44 -50.129)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M369.854,195.243V194.2c0-.663,0-1.64.056-2.775,0-2.359.067-5.617.079-9.347l-.18.191h3.516l-.191-.191h0v7.459c0,2.247,0,4.156.056,5.7l.112-.112-2.561.056c-.607,0-.944,0-.955.056a6.922,6.922,0,0,0,.887,0l2.629.056h.112V182.021h0l-.191-.191H369.63v.18c0,3.808,0,7.122.09,9.47v2.741A6.1,6.1,0,0,0,369.854,195.243Z",
    transform: "translate(-254.865 -51.277)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M399.711,195.917a2.112,2.112,0,0,0,0-.4v-1.123c0-1.011,0-2.381.056-4.078,0-3.437.067-8.2.079-13.6l-.191.18h3.527l-.191-.18h0v11.121c0,3.258.056,6.021.067,8.043l.1-.1h-3.527a6.355,6.355,0,0,0,.888,0l2.64.056h.1v-.1c0-2.022,0-4.786.067-8.043V176.561h0l-.191-.191H399.43v.191c0,5.482,0,10.313.079,13.739,0,1.674,0,3.033.056,4.033v1.123C399.565,195.793,399.711,195.928,399.711,195.917Z",
    transform: "translate(-318.255 -51.951)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M377.418,196.437a3.151,3.151,0,0,0,0-.494V194.55c0-1.224,0-2.943.056-5.078,0-4.3,0-10.245.079-16.952l-.191.191h3.528c-.382-.382-.1-.1-.191-.18h0v14.11c0,4.089.056,7.459.079,9.8l.09-.09h.09v-.09c0-2.337,0-5.707.067-9.8v-14.11h0c-.09-.09.191.18-.191-.2h-3.707v.18c0,6.74.056,12.75.079,17.087,0,2.112,0,3.82.056,5.033V195.8A1.507,1.507,0,0,0,377.418,196.437Z",
    transform: "translate(-270.91 -52.473)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M384.773,197.806a1.279,1.279,0,0,0,0-.191v-2.741c0-1.876,0-4.561.056-7.864,0-6.673.056-15.9.09-26.253l-.191.191h3.561l-.18-.18h0v22.367c0,6.381.067,11.492.09,14.6l.068-.067h.045v-.079c0-3.168,0-8.279.079-14.6V160.622h0c-.079-.09.191.18-.191-.2h-3.707v.191c0,10.4,0,19.682.079,26.388,0,3.3,0,5.976.056,7.863v2.651C384.762,197.761,384.762,197.817,384.773,197.806Z",
    transform: "translate(-286.556 -53.92)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M392.516,200.6v-4.909c0-3.157,0-7.718.056-13.346,0-11.234,0-26.882.079-44.295l-.191.191h3.527c-.371-.371-.112-.09-.191-.169v39.138c0,10.9.078,19.176.1,23.389h.056v-.067c0-4.213.056-12.492.09-23.389V138.023c-.09-.09.191.169-.191-.213h-3.707v.213c0,17.469,0,33.117.079,44.43,0,5.617,0,10.111.056,13.3v4.516A.373.373,0,0,0,392.516,200.6Z",
    transform: "translate(-302.803 -56.709)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M150.616,197l-3,52.608L59.6,244.586Zm-14.705,20.412L98.053,237.633l36.589,2.056Z",
    transform: "translate(316.216 -49.406)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M64.41,201.09a10.8,10.8,0,0,0,1.393,3.269,10.62,10.62,0,0,0,1.943,3,10.684,10.684,0,0,0-1.393-3.3A10.786,10.786,0,0,0,64.41,201.09Z",
    transform: "translate(393.683 -48.902)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M76.45,207.3a10.559,10.559,0,0,0,1.393,3.224,10,10,0,0,0,1.921,2.91,10.246,10.246,0,0,0-1.382-3.224A9.708,9.708,0,0,0,76.45,207.3Z",
    transform: "translate(368.139 -48.135)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M87.89,213.51a10.287,10.287,0,0,0,1.708,3.044,9.591,9.591,0,0,0,2.247,2.7,10.266,10.266,0,0,0-1.708-3.056A9.862,9.862,0,0,0,87.89,213.51Z",
    transform: "translate(343.207 -47.369)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M99.71,220a9.683,9.683,0,0,0,1.708,3.056,10.355,10.355,0,0,0,2.247,2.7,9.684,9.684,0,0,0-1.707-3.055A10.359,10.359,0,0,0,99.71,220Z",
    transform: "translate(318.109 -46.568)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M112.35,226.33a10.637,10.637,0,0,0,1.55,3.247,10.75,10.75,0,0,0,2.067,2.921A20.446,20.446,0,0,0,112.35,226.33Z",
    transform: "translate(291.606 -45.787)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M125.46,233a9.293,9.293,0,0,0,1.371,3.078,9.572,9.572,0,0,0,1.91,2.775,9.469,9.469,0,0,0-1.382-3.089A9.087,9.087,0,0,0,125.46,233Z",
    transform: "translate(264.105 -44.965)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M69.627,203.05c-.146.09.1.854.562,1.73s.955,1.494,1.123,1.415-.1-.854-.562-1.719S69.773,202.994,69.627,203.05Z",
    transform: "translate(384.253 -48.66)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M73.558,205c-.157.079.1.854.562,1.719s.944,1.505,1.123,1.427-.112-.854-.562-1.73S73.7,204.933,73.558,205Z",
    transform: "translate(375.906 -48.42)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M82.327,209.651c-.146.09.1.854.562,1.73s.955,1.505,1.123,1.415-.1-.854-.562-1.719S82.473,209.572,82.327,209.651Z",
    transform: "translate(357.285 -47.846)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M86.267,211.621c-.146.079.1.854.562,1.719s.955,1.505,1.123,1.427-.1-.854-.562-1.73S86.424,211.542,86.267,211.621Z",
    transform: "translate(348.92 -47.604)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M94.2,216.061c-.157.079.1.854.562,1.719s.944,1.505,1.123,1.427-.1-.854-.562-1.73S94.343,215.993,94.2,216.061Z",
    transform: "translate(332.081 -47.055)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M97.957,218c-.157.079.1.854.562,1.719s.944,1.505,1.123,1.427-.1-.865-.562-1.73A3.316,3.316,0,0,0,97.957,218Z",
    transform: "translate(324.097 -46.816)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M106.063,222.241c-.146.09.1.854.562,1.73s.944,1.494,1.123,1.415-.1-.854-.562-1.719S106.209,222.162,106.063,222.241Z",
    transform: "translate(306.881 -46.293)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M110.427,224.551c-.146.09.1.854.562,1.73s.955,1.505,1.123,1.416-.1-.854-.562-1.719S110.573,224.472,110.427,224.551Z",
    transform: "translate(297.619 -46.008)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M118.267,228.681c-.146.079.1.854.562,1.719s.955,1.505,1.123,1.427-.1-.854-.562-1.73S118.424,228.6,118.267,228.681Z",
    transform: "translate(280.972 -45.498)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M122.787,231c-.146.09.1.865.562,1.73s.955,1.505,1.123,1.415-.1-.854-.562-1.719S122.933,230.922,122.787,231Z",
    transform: "translate(271.374 -45.213)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M158.168,136.256V125.247c0-6.965.056-16.851.09-28.8l-.168.157H197.9l-.18-.191v39.813l.157-.169-28.8.09h-.112l28.916.079h.281V96.05H158v.169c0,11.953.056,21.917.079,28.916v10.9Z",
    transform: "translate(158.131 -61.861)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M176.055,137.362a2.694,2.694,0,0,0-.3-.213l-.91-.584-3.527-2.247-12.964-8.01.067.124V87.215l-.18.191h39.285l13.4,7.448,3.662,2.045.955.517.326.168q-.146-.109-.3-.2l-.944-.562L211,94.719,197.7,87.08H158.16v39.487h.068l13.031,7.965,3.561,2.157.932.55Z",
    transform: "translate(140.243 -62.969)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M193.6,87.16c-.056.09,3.876,2.483,8.785,5.347s8.987,5.123,8.987,5.033-3.876-2.483-8.8-5.359S193.646,87.07,193.6,87.16Z",
    transform: "translate(104.927 -62.959)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M158.157,130.383a2.1,2.1,0,0,0,.854.708c.517.292.989.472,1.034.382s-.326-.4-.842-.708S158.213,130.293,158.157,130.383Z",
    transform: "translate(196.067 -57.629)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M161.522,128.453c-.056.09.326.416.854.708s.988.472,1.033.382-.326-.4-.854-.708S161.578,128.363,161.522,128.453Z",
    transform: "translate(188.928 -57.867)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M164.881,126.523c-.056.09.326.416.843.708s.988.472,1.045.382-.326-.4-.854-.708S164.926,126.433,164.881,126.523Z",
    transform: "translate(181.795 -58.105)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M168.235,124.593a2.2,2.2,0,0,0,.854.708c.517.3.989.472,1.045.382s-.337-.4-.854-.708S168.291,124.5,168.235,124.593Z",
    transform: "translate(174.654 -58.344)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M171.607,122.663c0,.09.326.4.854.708s.989.472,1.034.382-.326-.4-.843-.708S171.663,122.573,171.607,122.663Z",
    transform: "translate(167.508 -58.582)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M174.14,119.27c-.1,0-.18.483-.18,1.123s.09,1.123.2,1.123.18-.483.18-1.123S174.241,119.259,174.14,119.27Z",
    transform: "translate(164.021 -58.996)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M174.171,115.39c-.1,0-.191.483-.18,1.123s.09,1.123.191,1.123.191-.494.191-1.123S174.272,115.39,174.171,115.39Z",
    transform: "translate(163.956 -59.475)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M174.2,111.51c-.1,0-.191.494-.18,1.123s.09,1.123.191,1.123.191-.494.191-1.123S174.3,111.51,174.2,111.51Z",
    transform: "translate(163.892 -59.953)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M174.24,107.63c-.1,0-.191.494-.18,1.123s.09,1.123.191,1.123.191-.483.18-1.123S174.341,107.63,174.24,107.63Z",
    transform: "translate(163.819 -60.434)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M174.27,103.76c-.1,0-.191.483-.18,1.123s.09,1.123.191,1.123.191-.483.18-1.123S174.371,103.76,174.27,103.76Z",
    transform: "translate(163.756 -60.91)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M174.3,99.88c-.112,0-.191.483-.18,1.123s.09,1.123.191,1.123.191-.494.18-1.123S174.4,99.88,174.3,99.88Z",
    transform: "translate(163.691 -61.389)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M174.33,96c-.112,0-.191.494-.18,1.123s.09,1.123.191,1.123.191-.494.18-1.123S174.431,96,174.33,96Z",
    transform: "translate(163.628 -61.867)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M174.36,92.12c-.112,0-.191.494-.18,1.123s.09,1.123.191,1.123.191-.483.18-1.123S174.461,92.12,174.36,92.12Z",
    transform: "translate(163.564 -62.346)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M174.39,88.25c-.112,0-.191.483-.18,1.123s.09,1.123.191,1.123.191-.483.18-1.123S174.491,88.25,174.39,88.25Z",
    transform: "translate(163.5 -62.824)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M209.737,122.1c0-.09-.483-.169-1.123-.169s-1.123.079-1.123.169.483.18,1.123.18S209.737,122.2,209.737,122.1Z",
    transform: "translate(90.958 -58.668)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M205.857,122.1c0-.09-.483-.169-1.123-.169s-1.123.079-1.123.169.494.18,1.123.18S205.857,122.2,205.857,122.1Z",
    transform: "translate(99.197 -58.668)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M201.977,122.1c0-.09-.483-.169-1.123-.169s-1.123.079-1.123.169.483.18,1.123.18S201.977,122.2,201.977,122.1Z",
    transform: "translate(107.436 -58.668)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M198.1,122.1c0-.09-.494-.169-1.123-.169s-1.124.079-1.124.169.483.18,1.124.18S198.1,122.2,198.1,122.1Z",
    transform: "translate(115.675 -58.668)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M194.247,122.1c0-.09-.483-.169-1.124-.169s-1.123.079-1.123.169.483.18,1.123.18S194.247,122.2,194.247,122.1Z",
    transform: "translate(123.85 -58.668)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M190.347,122.1c0-.09-.483-.169-1.123-.169s-1.123.079-1.123.169.494.18,1.123.18S190.347,122.2,190.347,122.1Z",
    transform: "translate(132.131 -58.668)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M186.467,122.1c0-.09-.483-.169-1.123-.169s-1.123.079-1.123.169.483.18,1.123.18S186.467,122.2,186.467,122.1Z",
    transform: "translate(140.369 -58.668)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M182.587,122.1c0-.09-.494-.169-1.123-.169s-1.123.079-1.123.169.483.18,1.123.18S182.587,122.2,182.587,122.1Z",
    transform: "translate(148.608 -58.668)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M178.717,122.1c0-.09-.483-.169-1.123-.169s-1.123.079-1.123.169.483.18,1.123.18S178.717,122.2,178.717,122.1Z",
    transform: "translate(156.826 -58.668)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M174.581,122.1c0-.09-.1-.169-.225-.169s-.236.079-.236.169a.218.218,0,0,0,.236.18.2.2,0,0,0,.225-.18Z",
    transform: "translate(163.602 -58.668)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M216.395,111.474a5.167,5.167,0,0,1-1,0,3.112,3.112,0,0,1-2.067-1.562,4.179,4.179,0,0,1,.112-3.786,1.123,1.123,0,0,1,.786-.629,1.393,1.393,0,0,1,1.011.27,4.807,4.807,0,0,1,1.269,2.112,9.785,9.785,0,0,1,.562,2.707h.371c0-2.887.056-5.4.056-7.2v-2.112a3.179,3.179,0,0,0,0-.764,3.846,3.846,0,0,0-.079.764,18.958,18.958,0,0,1-.09,2.112c-.067,1.8-.135,4.314-.191,7.2h.371a10.106,10.106,0,0,0-.584-2.809,11.115,11.115,0,0,0-.539-1.236,3.067,3.067,0,0,0-.854-1.045,1.741,1.741,0,0,0-1.3-.337,1.528,1.528,0,0,0-1.011.809,4.4,4.4,0,0,0,0,4.1,3.134,3.134,0,0,0,2.247,1.561,2.362,2.362,0,0,0,.764,0A.7.7,0,0,0,216.395,111.474Z",
    transform: "translate(77.313 -61.311)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M93,276.6a1.292,1.292,0,0,0-.461.135c-.3.135-.753.236-1.326.472a25.847,25.847,0,0,0-4.786,2.494,26.55,26.55,0,0,0-6.291,5.785,23.4,23.4,0,0,0-4.7,10.245,22.815,22.815,0,0,0,1.741,13.481,21.2,21.2,0,0,0,4.381,6.291,20.367,20.367,0,0,0,3.134,2.539c.6.337,1.123.7,1.8,1.011s1.236.618,1.9.854c5.235,2.078,11.234,2.168,17.255,1.6,3.011-.292,6.044-.73,9.133-1.213a55.3,55.3,0,0,0,9.245-2.146,23.421,23.421,0,0,0,8.279-4.651,18.728,18.728,0,0,0,3.033-3.573,19.308,19.308,0,0,0,1.943-4.19,21.714,21.714,0,0,0,.887-8.863,23.714,23.714,0,0,0-2.449-8.167,27.288,27.288,0,0,0-11.144-10.964,36.884,36.884,0,0,0-13.054-4.157A51.077,51.077,0,0,0,100.2,273.5a75.531,75.531,0,0,0-8.437,1.382c-2.247.517-4.044.989-5.235,1.314l-1.348.393-.461.157.472-.112,1.359-.348c1.191-.3,2.954-.753,5.246-1.236a75.436,75.436,0,0,1,8.437-1.292,50.05,50.05,0,0,1,11.234.135,36.843,36.843,0,0,1,12.908,4.168,26.961,26.961,0,0,1,10.953,10.83,23.177,23.177,0,0,1,2.37,8.043,21.412,21.412,0,0,1-.876,8.684,18.444,18.444,0,0,1-1.887,4.089A18.057,18.057,0,0,1,132,313.189a23.229,23.229,0,0,1-8.122,4.561,55.22,55.22,0,0,1-9.189,2.123c-3.067.483-6.111.921-9.1,1.213-5.954.573-11.919.494-17.064-1.55A19.962,19.962,0,0,1,77.5,309.089a22.625,22.625,0,0,1-1.775-13.278A23.311,23.311,0,0,1,80.32,285.7a26.8,26.8,0,0,1,6.179-5.785,28.094,28.094,0,0,1,4.729-2.561c.573-.236,1.011-.382,1.314-.506Z",
    transform: "translate(311.122 -40.002)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M83.069,303.631a3.605,3.605,0,0,0,.91.112l2.505.124h.831a3.5,3.5,0,0,0,.955,0,.821.821,0,0,0,.472-.382,1.38,1.38,0,0,0,.146-.539l.067-1.022c.079-1.416.169-2.943.258-4.494s.191-3.134.2-4.561a4.056,4.056,0,0,0-.472-2.011,2.83,2.83,0,0,0-1.37-1.123,5.716,5.716,0,0,0-2.528-.281,2.95,2.95,0,0,0-.91.168,5.277,5.277,0,0,0,.921,0,5.934,5.934,0,0,1,2.393.393,2.427,2.427,0,0,1,1.123,1.067,3.774,3.774,0,0,1,.393,1.82c0,1.37-.168,2.932-.236,4.493s-.157,3.134-.236,4.494c-.067.663.079,1.494-.382,1.606a2.921,2.921,0,0,1-.843,0H83.9a3.282,3.282,0,0,0-.831.135Z",
    transform: "translate(351.051 -38.004)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M83.43,295.544a6.549,6.549,0,0,0,2.337.27,6.426,6.426,0,0,0,2.348-.18,6.273,6.273,0,0,0-2.337-.27,6.384,6.384,0,0,0-2.348.18Z",
    transform: "translate(351.947 -37.275)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M91.67,293.7a19.95,19.95,0,0,0,3.561.18,22.54,22.54,0,0,0,3.55,0,10.546,10.546,0,0,0-3.539-.483A11.04,11.04,0,0,0,91.67,293.7Z",
    transform: "translate(332.024 -37.518)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M92.37,298.468a11.45,11.45,0,0,0,3.527.247,11.159,11.159,0,0,0,3.494-.416,18.333,18.333,0,0,0-3.5,0A19.459,19.459,0,0,0,92.37,298.468Z",
    transform: "translate(330.628 -36.918)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M106.243,302.253v-1.371a13.625,13.625,0,0,1,.674-3.685,3.752,3.752,0,0,1,1.3-2.123,1.124,1.124,0,0,1,1.225.079,3.08,3.08,0,0,1,.932,1.123,15.728,15.728,0,0,1,1.123,6.976h.438a29.581,29.581,0,0,1,.067-5.168,20.606,20.606,0,0,1,.292-2.078,2.7,2.7,0,0,1,.944-1.617,1.4,1.4,0,0,1,1.64,0,2.494,2.494,0,0,1,1.033,1.415,9.6,9.6,0,0,1,.315,1.786c.067.6.124,1.18.146,1.752a27.654,27.654,0,0,1,0,3.2h.348c.09-2.527.168-4.594.225-6.111v-1.663a2.348,2.348,0,0,0,0-.584,3.086,3.086,0,0,0-.079.584l-.135,1.663c-.09,1.505-.225,3.572-.382,6.089h.348a30.5,30.5,0,0,0,0-3.235,17.232,17.232,0,0,0-.135-1.775,9.419,9.419,0,0,0-.326-1.865,2.932,2.932,0,0,0-1.191-1.663,2.045,2.045,0,0,0-1.123-.315,1.91,1.91,0,0,0-1.123.371,3.134,3.134,0,0,0-1.123,1.876,19.991,19.991,0,0,0-.314,2.135,30.45,30.45,0,0,0,0,5.246h.438a15.728,15.728,0,0,0-1.236-7.133,3.291,3.291,0,0,0-1.123-1.28,1.471,1.471,0,0,0-1.6-.079,3.989,3.989,0,0,0-1.4,2.325,13.052,13.052,0,0,0-.562,3.774,4.983,4.983,0,0,0,.056,1.022,1.39,1.39,0,0,0,.3.326Z",
    transform: "translate(297.87 -37.479)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M118.069,301.566a1.745,1.745,0,0,0,.539.382,4.257,4.257,0,0,0,1.741.427,4.561,4.561,0,0,0,2.584-.708,4.493,4.493,0,0,0,1.438-5.943,4.606,4.606,0,0,0-1.977-1.809,4.2,4.2,0,0,0-1.741-.416,1.56,1.56,0,0,0-.652.09,6.472,6.472,0,0,1,2.247.607,4.492,4.492,0,0,1,1.753,1.73,4.235,4.235,0,0,1-1.3,5.4,4.428,4.428,0,0,1-2.359.73A6.169,6.169,0,0,1,118.069,301.566Z",
    transform: "translate(276.204 -37.5)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M121.24,290.185a22.969,22.969,0,0,1,5,.865l.753.247-.562-.573a15.649,15.649,0,0,1-2.786-3.37,5.056,5.056,0,0,1-.584-3.449c.124-.528.438-.944.865-.955a2.742,2.742,0,0,1,1.269.337,4.953,4.953,0,0,1,1.55,1.247c.3.371.427.618.461.6a1.494,1.494,0,0,0-.326-.7,4.257,4.257,0,0,0-1.539-1.415,2.9,2.9,0,0,0-1.438-.438,1.123,1.123,0,0,0-.82.393,1.966,1.966,0,0,0-.416.82,5.336,5.336,0,0,0,.584,3.775,14.516,14.516,0,0,0,2.909,3.471l.191-.337a13.884,13.884,0,0,0-3.685-.584,4.047,4.047,0,0,0-1.427.068Z",
    transform: "translate(270.382 -38.848)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M281.007,278.027l-23.939-4.617-45.924,10.537L187.867,288.8l-.337,31.8,51.923,9.56,35.038-10.38,13.245-19.491Z",
    transform: "translate(35.382 -39.98)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M280.239,280.925,257.648,275.6s-15.974,49.429-55.394,47.26c-32.129-1.741-32.162-34.33-32.162-34.33l-23.49,4.145s-9.852,59.64.944,101.475c8.987,34.825,16.963,82.546,16.963,82.546H320.557Z",
    transform: "translate(53.157 -39.711)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M288.19,431.888s64.358-112.754,75.94-127.223c12.683-15.84,22.8-14.009,22.8-14.009l6.807,75.952-54.72,77.637-13.042,4.707Z",
    transform: "translate(-183.704 -37.861)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M130.093,279.78s36.577,2.921,49.7,62.909c5.931,27.107,13.481,58.876,15.592,80.221,1.573,15.491-7.987,31.6-23.434,33.578l-19.389,3.595a20.355,20.355,0,0,1-23.5-15.233l-6.549-27.118,17.446-5.864-4.033-80.782Z",
    transform: "translate(200.608 -39.195)",
    fill: "#fb5d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M293.384,328.12a3.975,3.975,0,0,0-.168.831c-.1.607-.214,1.416-.371,2.415-.079.528-.157,1.123-.258,1.753s-.135,1.337-.2,2.09c-.157,1.494-.337,3.2-.416,5.1a122.938,122.938,0,0,0-.09,13.335,159.99,159.99,0,0,0,1.618,16.244c.843,5.729,1.9,11.144,2.966,16.042s2.135,9.29,3.044,12.975,1.708,6.639,2.247,8.684c.27.977.483,1.764.651,2.348a6.35,6.35,0,0,0,.258.809,4.583,4.583,0,0,0-.146-.831c-.135-.607-.326-1.393-.55-2.381l-2.067-8.774c-.865-3.7-1.9-8.088-2.921-12.986s-2.078-10.3-2.921-16.019-1.415-11.234-1.651-16.188a118.49,118.49,0,0,1,0-13.278c0-1.887.2-3.595.326-5.1.056-.742.112-1.438.157-2.089s.146-1.213.2-1.753c.113-1,.191-1.809.258-2.415a6.077,6.077,0,0,0,.034-.809Z",
    transform: "translate(-96.613 -33.23)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M169.34,414.241a3.117,3.117,0,0,0,.191-.494c.112-.371.27-.843.461-1.449l.719-2.326a6.932,6.932,0,0,1,1.3-2.909,9.29,9.29,0,0,1,3.37-2.067,27.082,27.082,0,0,1,4.561-1.281,67.641,67.641,0,0,1,11.234-1.123h.3V402.3l-3.3-21.535c-2.123-13.559-4.055-25.838-5.46-34.825-.73-4.4-1.314-7.987-1.73-10.526-.2-1.2-.371-2.157-.494-2.865a3.081,3.081,0,0,0-.146-.741.743.743,0,0,0-.067-.247.65.65,0,0,0,0,.258,2.466,2.466,0,0,0,.09.753c.09.708.225,1.662.382,2.876.371,2.55.9,6.145,1.539,10.56,1.371,8.987,3.235,21.243,5.3,34.825,1.213,7.751,2.348,15.087,3.37,21.524l.258-.3a66.869,66.869,0,0,0-11.357,1.269,26.95,26.95,0,0,0-4.617,1.359,9.346,9.346,0,0,0-3.471,2.247,4.178,4.178,0,0,0-.876,1.562l-.416,1.494c-.258.91-.472,1.7-.652,2.348s-.292,1.123-.382,1.472A2.427,2.427,0,0,0,169.34,414.241Z",
    transform: "translate(152.07 -32.807)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M173.082,415.654a6.333,6.333,0,0,0-.292-1.505,23.46,23.46,0,0,0-1.415-3.943,26.837,26.837,0,0,0-21.468-15.626,23.436,23.436,0,0,0-4.179-.135,6.834,6.834,0,0,0-1.528.191,49.964,49.964,0,0,1,5.617.349,27.691,27.691,0,0,1,21.153,15.39A53.137,53.137,0,0,1,173.082,415.654Z",
    transform: "translate(198.712 -25.053)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M171.954,386.749a2.773,2.773,0,0,0-.876-.078,18.606,18.606,0,0,0-2.415.112,27.54,27.54,0,0,0-7.718,1.932,28.153,28.153,0,0,0-6.853,4.055,18.093,18.093,0,0,0-1.786,1.618c-.393.415-.607.651-.573.685s.988-.786,2.606-1.977a32.378,32.378,0,0,1,14.379-5.909C170.707,386.9,171.954,386.85,171.954,386.749Z",
    transform: "translate(191.381 -26.008)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M175.9,321.912a9.105,9.105,0,0,0,.079-1.606c0-1.034.068-2.516.2-4.348a70.88,70.88,0,0,1,2.449-14.121,72.1,72.1,0,0,1,5.269-13.323c.854-1.629,1.573-2.932,2.1-3.808a9.083,9.083,0,0,0,.764-1.416,8.471,8.471,0,0,0-.955,1.292,40.821,40.821,0,0,0-2.247,3.741,62.908,62.908,0,0,0-7.751,27.613,42.71,42.71,0,0,0,0,4.37,8.134,8.134,0,0,0,.09,1.606Z",
    transform: "translate(149.572 -38.762)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    transform: "translate(191.179 292.406)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M305.525,378.709c-9.324-15.806-9.526-36.341-1.382-52.8a147.5,147.5,0,0,0,1.663,52.731",
    transform: "translate(-298.27 -325.91)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M142.54,436.11a1.661,1.661,0,0,0,.281.3,7.732,7.732,0,0,0,.91.775,14.227,14.227,0,0,0,3.864,2.045,22.167,22.167,0,0,0,6.381,1.124,58.432,58.432,0,0,0,7.864-.281c5.617-.483,10.6-1.3,14.211-1.943,1.809-.326,3.269-.607,4.269-.82a7.653,7.653,0,0,0,1.561-.382,9.675,9.675,0,0,0-1.6.157l-4.3.629c-3.617.55-8.628,1.292-14.2,1.775a63.956,63.956,0,0,1-7.864.326,22.934,22.934,0,0,1-6.268-1.011A19.322,19.322,0,0,1,142.54,436.11Z",
    transform: "translate(191.778 -19.906)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M280.544,173.493,275.927,169c-6.145,2.674-8.987,9.807-10.032,16.435s-.888,13.593-3.707,19.682c-2.157,4.684-6.078,8.987-5.617,14.166.438,4.887,4.864,8.841,4.887,13.75,0,4.729-3.932,8.358-6.224,12.492-4.639,8.369-7.65,42.61-5.224,51.878,20.412-1.764,56.562-3.943,76.985-8.639C321.615,253.579,298.956,203.926,280.544,173.493Z",
    transform: "translate(-73.101 -52.863)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M264.81,295.87Z",
    transform: "translate(-28.507 -37.209)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M212.588,206.3c-1.415-23.917,15.952-45.8,40.161-48.687,25.692-3.056,48.418,15.345,50.552,40.374l6.021,101.037a8.774,8.774,0,0,1-1.55,5.493c-5.931,8.673-16.671,15.458-26.276,16.794-9.29,1.292-18.716-1.123-26.624-5.527a8.605,8.605,0,0,1-4.37-7.392l-.416-22.613a.135.135,0,0,0-.146-.146,30.7,30.7,0,0,1-6.347-.18c-5.976-1.46-21.221-7.324-26.343-29.7C215.543,248.34,213.835,227.277,212.588,206.3Z",
    transform: "translate(-14.278 -54.309)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M279.435,233.934c0-.225-2.505-.472-6.561-.7-1.022,0-2-.168-2.247-.843a5.032,5.032,0,0,1,.494-3.011l2.516-7.864c3.482-11.144,5.931-20.277,5.482-20.4s-3.651,8.785-7.133,19.929q-1.247,4.129-2.393,7.864c-.315,1.123-.887,2.494-.27,3.966a2.506,2.506,0,0,0,1.764,1.337,6.955,6.955,0,0,0,1.741.124C276.919,234.316,279.424,234.159,279.435,233.934Z",
    transform: "translate(-47.896 -48.9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M280.4,208.917c.438.483,3.089-1.741,6.886-1.854s6.628,1.876,7.032,1.359c.2-.236-.259-1.123-1.494-2.045a9.111,9.111,0,0,0-5.617-1.707,8.986,8.986,0,0,0-5.471,2.1C280.559,207.782,280.12,208.7,280.4,208.917Z",
    transform: "translate(-75.485 -48.463)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M244.908,209.847c.517.483,3.28-2.022,7.425-2.382s7.369,1.539,7.785.977c.2-.258-.359-1.123-1.764-2.045a10.313,10.313,0,0,0-6.246-1.393,10.11,10.11,0,0,0-5.864,2.55C245.02,208.645,244.661,209.634,244.908,209.847Z",
    transform: "translate(-1.415 -48.426)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M234.99,272.908s15.48.168,33.993-12.548c0,0-4.786,20.423-33.87,19.783Z",
    transform: "translate(0.818 -41.59)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M256.639,238.968a7.29,7.29,0,0,1,6.269-3.067,6.559,6.559,0,0,1,4.684,2.067,4.033,4.033,0,0,1,.618,4.651c-.977,1.562-3.2,2.067-5.145,1.662a15.176,15.176,0,0,1-5.3-2.651,4.678,4.678,0,0,1-1.214-1.124,1.314,1.314,0,0,1-.09-1.46",
    transform: "translate(-22.796 -44.609)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M269.789,232c-.652,0-.393,4.269-3.9,7.549s-8.145,3.123-8.145,3.718c0,.281,1.123.764,3.033.674a10.986,10.986,0,0,0,6.808-2.865,9.235,9.235,0,0,0,2.988-6.3C270.632,232.988,270.081,232,269.789,232Z",
    transform: "translate(-26.342 -45.09)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M242.72,195.762c.472,1.034,4.415.236,9.122.427s8.583,1.123,9.144.169c.236-.483-.483-1.427-2.09-2.348a16.064,16.064,0,0,0-13.907-.449C243.361,194.369,242.563,195.268,242.72,195.762Z",
    transform: "translate(0.109 -50)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M279.508,196.563c.809.9,4.01,0,7.863,0s7.089.64,7.864-.292c.337-.449-.169-1.348-1.584-2.247a13.1,13.1,0,0,0-12.649.27C279.609,195.2,279.148,196.125,279.508,196.563Z",
    transform: "translate(-75.412 -49.959)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M210.437,153.765c2.089-3.55,5.965-5.168,10.3-5.819,17.7-2.685,37.453,7.976,47.373,22.872s10.447,37.128,3.19,53.484l-11.043-6.9c-22.164-9.144-37.813-30.5-52.069-52.563C206.2,161.842,208.583,156.854,210.437,153.765Z",
    transform: "translate(24.529 -55.512)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M280.2,163.17c7.4-8.425,12.784-16.851,28.152-10.964,2.247,4.3-2.247,9.886-6.111,13.144-5.617,4.786-10.436,8.01-14.1,11.436-7.392,6.909-15.795,30.152-16.525,42.834,0,.8-1.4-10.885-2.247-11.009-1.034-.157-5.2-5.257-4.628-12.222C266.715,172.584,272.793,171.584,280.2,163.17Z",
    transform: "translate(-72.506 -55.176)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M270.512,147.913a6.326,6.326,0,0,0-3.449.292,14.919,14.919,0,0,0-6.987,4.595,12.537,12.537,0,0,0-1.393,1.966,10.041,10.041,0,0,0-.809,2.123,23.225,23.225,0,0,0-.91,3.64c-.3,2.168.213,3.482.326,3.449a26.288,26.288,0,0,1,.416-3.314,33.851,33.851,0,0,1,1.123-3.471,10.749,10.749,0,0,1,.787-1.921,12.676,12.676,0,0,1,1.3-1.82,16.512,16.512,0,0,1,6.415-4.561C269.242,148.2,270.534,148.093,270.512,147.913Z",
    transform: "translate(-25.289 -55.479)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M283.669,215.337a3.37,3.37,0,0,0,3.179,3.37,3.224,3.224,0,0,0,3.516-2.977,3.37,3.37,0,0,0-3.179-3.449,3.213,3.213,0,0,0-3.516,3.056Z",
    transform: "translate(-75.248 -47.523)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M250.73,215.489a3.37,3.37,0,0,0,3.179,3.449,3.213,3.213,0,0,0,3.516-2.966,3.37,3.37,0,0,0-3.179-3.46,3.213,3.213,0,0,0-3.516,2.977Z",
    transform: "translate(-5.305 -47.496)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M239.436,251.252c-2.09-3.437-4.494-6.673-8.313-8.1s-8.156-2.247-11.155-5.033c-4.707-4.325-4.493-11.515-4.067-17.783s.539-13.481-4.269-17.693c-4.022-3.516-10.414-3.831-13.9-7.864-2.326-2.685-2.786-6.392-3.595-9.818-2.247-9.178-7.268-25.209-34.319-34.432l23.928,90.926c-1.786.506-6.055,4.572-6.291,7.324-.213,2.573.9,5.179.921,7.762,0,3.157-3.437,5.044-5.617,7.381-2.764,2.977-3.617,7.268-3.19,11.234a78.875,78.875,0,0,0,4.325,15.851c22.2-2.247,54.6-2.966,71.514-17.12C248.479,271.327,244.087,258.9,239.436,251.252Z",
    transform: "translate(107.813 -55.141)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M205.8,209.883c.416-.225,16.761-6.74,17.806,10.5s-16.446,14.682-16.5,14.2S205.8,209.883,205.8,209.883Z",
    transform: "translate(78.943 -47.99)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M209.729,227.158c.079-.067.315.191.843.382a2.989,2.989,0,0,0,2.247-.079c1.775-.786,3.134-3.763,3.033-6.864a10.01,10.01,0,0,0-1.124-4.235,3.5,3.5,0,0,0-2.393-2.168,1.528,1.528,0,0,0-1.719.932c-.2.494-.067.831-.157.865s-.393-.27-.292-.989a1.876,1.876,0,0,1,.607-1.123,2.247,2.247,0,0,1,1.629-.539,4.2,4.2,0,0,1,3.292,2.471,10.233,10.233,0,0,1,1.326,4.741c.1,3.471-1.472,6.819-3.921,7.684a3.168,3.168,0,0,1-2.764-.292C209.785,227.563,209.673,227.192,209.729,227.158Z",
    transform: "translate(81.17 -47.393)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M308.193,215.532a27.21,27.21,0,0,0-.55-3.853,15.727,15.727,0,0,0-20.4-11.133,14.608,14.608,0,0,0-3.977,2.067,14.381,14.381,0,0,0-3.37,3.258,15.5,15.5,0,0,0-.292,18.423,14.606,14.606,0,0,0,3.235,3.37,14.357,14.357,0,0,0,3.909,2.19,15.627,15.627,0,0,0,8.19.831,15.458,15.458,0,0,0,6.639-2.8,15.818,15.818,0,0,0,5.92-8.5,29.231,29.231,0,0,0,.674-3.842,2.351,2.351,0,0,1,0,.258v.764a8,8,0,0,1-.124,1.225,10.775,10.775,0,0,1-.314,1.651,15.982,15.982,0,0,1-21.165,10.919,16.116,16.116,0,0,1-7.122-24.827,15.226,15.226,0,0,1,3.483-3.37,14.945,14.945,0,0,1,4.078-2.067,15.974,15.974,0,0,1,20.8,11.6,12.052,12.052,0,0,1,.27,1.663,8.825,8.825,0,0,1,.078,1.236v.753c.014.059.025.119.034.18Z",
    transform: "translate(-84.618 -49.135)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M269.34,216.158a28.026,28.026,0,0,0-.539-3.853,15.831,15.831,0,0,0-5.617-8.695,15.537,15.537,0,0,0-6.549-3.011,15.728,15.728,0,0,0-8.212.573,14.932,14.932,0,0,0-3.977,2.067,14.6,14.6,0,0,0-3.37,3.258,15.513,15.513,0,0,0-.3,18.412,14.712,14.712,0,0,0,3.247,3.37,14.321,14.321,0,0,0,3.909,2.191,15.627,15.627,0,0,0,8.189.831,15.4,15.4,0,0,0,6.628-2.8,15.851,15.851,0,0,0,5.932-8.5,28.137,28.137,0,0,0,.663-3.842.93.93,0,0,1,0,.258v.764a6.667,6.667,0,0,1-.112,1.224,9.681,9.681,0,0,1-.326,1.651,15.728,15.728,0,0,1-5.9,8.785,15.963,15.963,0,0,1-6.74,2.943,16.164,16.164,0,0,1-8.459-.809,16.118,16.118,0,0,1,.483-30.32,16.042,16.042,0,0,1,20.839,11.593,9.385,9.385,0,0,1,.27,1.663,6.317,6.317,0,0,1,.079,1.236v.753A.674.674,0,0,1,269.34,216.158Z",
    transform: "translate(-2.357 -49.063)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M277.884,213.735c-.09.056-.539-.674-1.584-1.517a7.661,7.661,0,0,0-9.571-.168c-1.124.8-1.55,1.517-1.629,1.449a4.021,4.021,0,0,1,1.37-1.775,7.516,7.516,0,0,1,10.111.191A4.057,4.057,0,0,1,277.884,213.735Z",
    transform: "translate(-41.907 -47.82)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M240.132,208.75a15.487,15.487,0,0,1-3.179.652c-1.988.315-4.741.607-7.774.876l-7.785.7a21.19,21.19,0,0,1-3.224.247,15.641,15.641,0,0,1,3.179-.663c1.977-.3,4.729-.6,7.774-.865l7.774-.7A19.7,19.7,0,0,1,240.132,208.75Z",
    transform: "translate(48.565 -47.959)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M303.149,223.68a20.352,20.352,0,0,1-3.37-5.426,20.646,20.646,0,0,1-.977-6.325,4.5,4.5,0,0,0-.337,1.91,12.425,12.425,0,0,0,.764,4.617,12.207,12.207,0,0,0,2.427,4C302.475,223.332,303.1,223.737,303.149,223.68Z",
    transform: "translate(-104.647 -47.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M302.231,206.593c-.09-.135-.73.191-1.123.955s-.225,1.46-.068,1.449.292-.584.6-1.2S302.332,206.717,302.231,206.593Z",
    transform: "translate(-106.448 -48.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M261.913,221.05c.09,0-.225-.9-.483-2.348a16.043,16.043,0,0,1,2.056-11.02c.753-1.258,1.359-1.955,1.292-2.022a6.1,6.1,0,0,0-1.64,1.8,14.287,14.287,0,0,0-2.168,11.324A6.136,6.136,0,0,0,261.913,221.05Z",
    transform: "translate(-23.756 -48.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M218.616,231.643a11.065,11.065,0,0,1,.573.955,5.977,5.977,0,0,1,.741,2.865,5.269,5.269,0,0,1-1.6,3.909,5.617,5.617,0,0,1-4.853,1.562,5.729,5.729,0,0,1-4.022-3.157,5.337,5.337,0,0,1-.124-4.224,6.1,6.1,0,0,1,1.685-2.427c.539-.461.9-.651.876-.7a2.583,2.583,0,0,0-1.011.517,5.763,5.763,0,0,0-1.932,2.449,5.616,5.616,0,0,0,0,4.606,5.931,5.931,0,0,0,9.751,1.753,5.616,5.616,0,0,0,1.629-4.3,5.742,5.742,0,0,0-.955-2.966A2.409,2.409,0,0,0,218.616,231.643Z",
    transform: "translate(79.26 -45.283)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M302.69,244.738a4.753,4.753,0,0,1-2.988.18,5.862,5.862,0,0,1-2.752-1.7,7.119,7.119,0,0,1-1.775-3.527,6.4,6.4,0,0,1,.472-3.909,7.147,7.147,0,0,1,2.011-2.573,11.686,11.686,0,0,1,2.7-1.472,1.934,1.934,0,0,0-.843.112,6.55,6.55,0,0,0-2.112,1.022,7.358,7.358,0,0,0-2.247,2.685,6.743,6.743,0,0,0-.562,4.235,7.514,7.514,0,0,0,1.977,3.808,6.067,6.067,0,0,0,3.044,1.719,4.192,4.192,0,0,0,2.348-.124C302.488,244.985,302.713,244.761,302.69,244.738Z",
    transform: "translate(-99.707 -45.123)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M227.335,447.215l-16.66,4.932s-9.189,3.943-13.66,4.965c-5.55,1.269-9.335-.449-9.538-3.539s4.112-3.483,4.112-3.483a85.356,85.356,0,0,0,10.672-4.932,18.906,18.906,0,0,0,5.954-6.74l-5.954.82s-12.526,8.987-17.244,11.706-5.752-2.056-6.156-3.494,13.952-16.008,13.952-16.008-13.75,8.83-16.21,11.032-6.167,2.921-6.987,1.494-3.078-1.438,0-7.527,27.714-22.468,27.714-22.468l-6.74-1.438-7.392,3.292a18.21,18.21,0,0,1-3.078,7.032c-2.662,3.954-7.392,0-7.392,0l2.932-15.165,14.6-9.144s15.188,1.854,17.446,2.876,4.729,5.325,4.729,5.325l4.1,1.663c6.37,1.842,6.156,8.212,8.212,8.414s61.977-11.481,61.977-11.481l5.426-1.416c8.987,6.819,12.571,18.086,14.155,28.084,0,0,1.651,4.9,0,7.594Z",
    transform: "translate(37.962 -24.541)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M242.783,434.544a3.067,3.067,0,0,0,.056-.977,5.615,5.615,0,0,0-.1-1.124,8.592,8.592,0,0,0-.292-1.505,21.236,21.236,0,0,0-4.19-7.718,45.907,45.907,0,0,0-6.2-6.212,18.355,18.355,0,0,0-2.91-2.168,30.118,30.118,0,0,0,2.64,2.426,58.145,58.145,0,0,1,6.021,6.268,23.14,23.14,0,0,1,4.235,7.471C242.7,433.151,242.66,434.555,242.783,434.544Z",
    transform: "translate(33.512 -22.531)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M238.647,405.85a8.583,8.583,0,0,1,1.258.876,13.647,13.647,0,0,1,2.73,3.134,14.907,14.907,0,0,1,1.37,2.527,13.632,13.632,0,0,1,.652,3.213,8.088,8.088,0,0,0,1.326,3.55,14.411,14.411,0,0,1,1.988,3.37,8.986,8.986,0,0,1,0,6.336l-.079.214.191.124a12.489,12.489,0,0,1,5.291,7.268,20.2,20.2,0,0,1,.506,3.595,2.919,2.919,0,0,0,.112-.966,11.3,11.3,0,0,0-.292-2.707,12.469,12.469,0,0,0-5.325-7.661l.112.337a9.616,9.616,0,0,0,0-6.74,13.9,13.9,0,0,0-2.067-3.449,7.6,7.6,0,0,1-1.258-3.37,10.572,10.572,0,0,0-2.247-5.875,12.256,12.256,0,0,0-2.943-3.089,4.486,4.486,0,0,0-1.011-.573A1.315,1.315,0,0,0,238.647,405.85Z",
    transform: "translate(11.699 -23.641)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M258.15,412.137a9.223,9.223,0,0,0,7.864-2.786c-.112-.135-1.618,1.022-3.786,1.775S258.15,411.969,258.15,412.137Z",
    transform: "translate(-22.229 -23.209)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M257.56,427.187a37.177,37.177,0,0,0,6.3-2.4,39.634,39.634,0,0,0,6.066-2.943,40.6,40.6,0,0,0-6.3,2.4A39.658,39.658,0,0,0,257.56,427.187Z",
    transform: "translate(-25.48 -21.668)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M250.86,434.189a53.973,53.973,0,0,0,6.381-2.629,8.345,8.345,0,0,0-3.37.876A8.039,8.039,0,0,0,250.86,434.189Z",
    transform: "translate(-5.267 -20.469)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M263.123,427.554a8.043,8.043,0,0,1,3.965,5c.079,0,.146-.394,0-1.022a5.247,5.247,0,0,0-2.988-3.786C263.55,427.509,263.146,427.486,263.123,427.554Z",
    transform: "translate(-28.978 -20.967)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M269.529,419.444c-.067.157,1.034.719,1.775,1.977a17.189,17.189,0,0,1,.944,2.472,2.977,2.977,0,0,0-.449-2.775C270.944,419.679,269.551,419.286,269.529,419.444Z",
    transform: "translate(-41.404 -21.967)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M271.494,405.347c.056,0,.281-.258.449-.8a4.232,4.232,0,0,0,0-2.247,4.179,4.179,0,0,0-1.123-1.91c-.4-.393-.741-.528-.775-.472a11.241,11.241,0,0,1,1.292,2.528,12.261,12.261,0,0,1,.157,2.9Z",
    transform: "translate(-41.673 -24.373)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M316.418,412.981s.753-14.739,16.03-17.794,42.037,9.931,42.037,9.931l74.974,52.248-2.247,6.459-76.1-10.6-6.965,2.674L310.7,420.777l-50.44-36.465,5.617-4.392s14.132,9.74,23.479,13.93S312.216,405.387,316.418,412.981Z",
    transform: "translate(-208.046 -26.84)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M455.024,465.813l-63.449-39.42L324.5,415.62s-3.37,4.875-9.066,3.684h0L260.275,381.11l-1.045,2.3L366.2,458.567a9.178,9.178,0,0,0,9.313-1.82Z",
    transform: "translate(-212.453 -26.693)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M330.01,411.83a2.477,2.477,0,0,0,.517.427l1.55,1.123c1.348.966,3.292,2.37,5.617,4.145,4.763,3.539,11.234,8.583,18.221,14.3s13.267,11.032,17.761,14.907l5.359,4.606,1.46,1.236a2.606,2.606,0,0,0,.528.4,4.591,4.591,0,0,0-.449-.483l-1.382-1.326c-1.213-1.123-2.977-2.763-5.2-4.729-4.426-3.954-10.638-9.3-17.659-15.042s-13.481-10.729-18.345-14.188c-2.4-1.741-4.393-3.089-5.786-4l-1.606-1.033A3.71,3.71,0,0,0,330.01,411.83Z",
    transform: "translate(-217.965 -22.902)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M261.05,405.439c6.077-6.527,15.649-8.852,24.546-8.156s17.334,4.011,25.636,7.3l77.614,53.125-.7,2-78.03-52.8s-17.435-5.617-25.152-6.583C272.07,398.721,261.05,405.439,261.05,405.439Z",
    transform: "translate(-148.319 -24.711)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M422.969,413.515,385.65,388.34S416.228,404.247,422.969,413.515Z",
    transform: "translate(-322.415 -25.801)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M392.7,457.732a1.9,1.9,0,0,0-.315-.258l-.966-.685-3.718-2.617-13.75-9.526-45.5-31.241-13.211-8.987h0a93.612,93.612,0,0,0-23.591-7.089,35.285,35.285,0,0,0-19.345,2.73,23.981,23.981,0,0,0-6.19,4.156,18.3,18.3,0,0,0-3.46,4.393,14.514,14.514,0,0,0-1.348,3.246c-.079.371-.146.663-.2.888a2.6,2.6,0,0,0-.056.3,18.349,18.349,0,0,1,1.775-4.336,18.806,18.806,0,0,1,3.483-4.28,24.778,24.778,0,0,1,6.156-4.044,35.263,35.263,0,0,1,19.1-2.561,94.413,94.413,0,0,1,23.411,7.044h-.056l13.211,8.987,45.531,31.129,13.863,9.38,3.774,2.516,1,.651A2.161,2.161,0,0,0,392.7,457.732Z",
    transform: "translate(-152.172 -24.734)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M385.439,416.623a2.447,2.447,0,0,0-.584-.359c-.393-.214-.977-.539-1.73-.921-1.517-.786-3.73-1.887-6.516-3.145a84.71,84.71,0,0,0-22.771-6.976,49.632,49.632,0,0,0-23.591,2.157,35.734,35.734,0,0,0-6.527,3.134,14.516,14.516,0,0,0-1.64,1.123,3.653,3.653,0,0,0-.55.416s.82-.472,2.3-1.314a39.613,39.613,0,0,1,6.549-2.932,50.821,50.821,0,0,1,23.4-1.966,89.875,89.875,0,0,1,22.681,6.74c2.8,1.213,5.033,2.247,6.583,2.977l1.775.82A3.4,3.4,0,0,0,385.439,416.623Z",
    transform: "translate(-212.854 -23.787)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M382.5,382.42a4.7,4.7,0,0,0,.483.371l1.449.966,5.381,3.46c4.561,2.921,10.841,6.954,17.727,11.492s13.042,8.706,17.536,11.739l5.314,3.572,1.46.955a2.382,2.382,0,0,0,.528.292,2.874,2.874,0,0,0-.461-.393l-1.4-1.045c-1.213-.9-2.988-2.168-5.2-3.73-4.426-3.112-10.582-7.347-17.48-11.885S394.61,389.7,390,386.869c-2.3-1.416-4.179-2.539-5.482-3.3l-1.517-.876a3.073,3.073,0,0,0-.505-.269Z",
    transform: "translate(-328.286 -26.531)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M337.873,420.345a26.16,26.16,0,0,0,2.887,5.19c1.438,1.708,6.134,4.089,6.5,7.336s-.393,10.863,4.685,16.66a28.511,28.511,0,0,0,12.031,7.864l20.03-1.955L416,442.847a2.808,2.808,0,0,0,2.044-3.37,4.044,4.044,0,0,0-3.37-3.011l-.764-.124s1.842-1.505-.8-4.145c-2.247-2.247-7.044-.977-9.515-.157s-16.963,6.875-19.558,7.807c-2.3.82-4.078,1.55-4.078,1.55s18.547-12.515,18.805-14.155c.3-1.966.1-2.865-1.8-4.235-2.247-1.629-5.932.113-9.5,1.618-2.662,1.123-19.637,9.5-19.637,9.5s-.764-.741,0-2.247,6.4-8.762,7.291-10.11,1.124-2.112.236-3.247c-1.236-1.606-4.494-2.37-7.493.371-1.9,1.753-8.65,6.291-8.65,6.291L328.055,402.45s-3.876-.1-2.528,5.3S337.873,420.345,337.873,420.345Z",
    transform: "translate(-249.71 -24.059)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M371,435.769a7.942,7.942,0,0,0,5.617-4.718c-.146-.09-1.056,1.3-2.606,2.6S370.924,435.6,371,435.769Z",
    transform: "translate(-259.608 -20.531)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M383.463,423.194c0-.067-.416-.191-1.123-.1a4.864,4.864,0,0,0-3.9,3.224c-.213.652-.18,1.123-.1,1.123a8.8,8.8,0,0,1,1.977-2.786A8.989,8.989,0,0,1,383.463,423.194Z",
    transform: "translate(-274.63 -21.516)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M377.606,429.514c.168,0,.247-1.674.91-3.584s1.6-3.314,1.461-3.37a6.279,6.279,0,0,0-2.011,3.224A6.189,6.189,0,0,0,377.606,429.514Z",
    transform: "translate(-270.245 -21.578)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M394.432,417.662c0,.056.393-.168.8-.708a5.156,5.156,0,0,0,.562-5c-.269-.606-.573-.91-.629-.865a7.346,7.346,0,0,1-.73,6.572Z",
    transform: "translate(-305.505 -22.994)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M359.42,442.939a4.9,4.9,0,0,0,2.191,0,14.6,14.6,0,0,0,4.943-1.842,27.357,27.357,0,0,0,4.258-3.089,7.31,7.31,0,0,0,1.539-1.528,8.74,8.74,0,0,0-1.8,1.2,42.176,42.176,0,0,1-4.291,2.909,17.7,17.7,0,0,1-4.729,1.943A19.087,19.087,0,0,0,359.42,442.939Z",
    transform: "translate(-242.33 -19.861)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M373.12,439.37c-.157,0-.169,1.123.775,2.056s2.09.888,2.067.73-.888-.382-1.652-1.124S373.288,439.348,373.12,439.37Z",
    transform: "translate(-261.242 -19.504)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M379.077,434.37c-.067,0-.067.3.146.708a2.764,2.764,0,0,0,1.27,1.123,2.833,2.833,0,0,0,1.7.247c.449-.09.674-.27.64-.337a5.43,5.43,0,0,1-2.09-.438C379.683,435.145,379.234,434.314,379.077,434.37Z",
    transform: "translate(-274.85 -20.121)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M329,447.3c.056.146,7.5-2.955,16.626-6.943s16.469-7.347,16.356-7.481-7.516,2.965-16.637,6.954S328.932,447.159,329,447.3Z",
    transform: "translate(-197.789 -20.307)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M277.828,348.719,253.45,468.393H41.861a4.224,4.224,0,0,1-4.224-4.224h0a4.224,4.224,0,0,1,4.224-4.235h42.6l22.6-111.338a4.606,4.606,0,0,1,4.494-3.7l161.688-1.73a4.628,4.628,0,0,1,4.583,5.549Z",
    transform: "translate(213.584 -31.373)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M278.141,348.73l.067-.36a4.617,4.617,0,0,0,0-1.123,4.672,4.672,0,0,0-2.247-3.494,4.491,4.491,0,0,0-1.393-.562,8,8,0,0,0-1.663-.1H269.1l-9.526.079-61.146.573-42.621.438-23.883.236-12.515.135-6.4.067h-1.64a4.934,4.934,0,0,0-1.64.483,4.82,4.82,0,0,0-2.314,2.427,7.518,7.518,0,0,0-.449,1.629l-.326,1.606c-.213,1.123-.438,2.157-.663,3.235q-.652,3.247-1.326,6.538-1.337,6.572-2.707,13.312Q99.2,387.33,96.322,401.406c-3.808,18.76-7.785,38.273-11.863,58.416l.281-.225H42.849a8.384,8.384,0,0,0-1.651.1,4.524,4.524,0,0,0-1.213,8.392,4.615,4.615,0,0,0,2,.539h211.96v-.18c7.459-36.791,13.481-66.706,17.716-87.444,2.089-10.357,3.707-18.423,4.808-23.905q.809-4.112,1.236-6.235c.281-1.415.4-2.134.4-2.134s-.169.719-.461,2.112-.741,3.5-1.3,6.224c-1.123,5.482-2.8,13.537-4.932,23.894-4.246,20.726-10.369,50.631-17.907,87.4l.225-.18-99.341-.056H42.029a4.094,4.094,0,0,1-1.73-.461,3.977,3.977,0,0,1-2.011-2.865,4.032,4.032,0,0,1,.652-2.842,3.987,3.987,0,0,1,2.415-1.606,8.375,8.375,0,0,1,1.528-.09H85.009v-.225c4.078-20.12,8.043-39.633,11.84-58.416q2.865-14.087,5.617-27.568l2.7-13.312c.438-2.191.887-4.37,1.326-6.527.213-1.123.438-2.168.652-3.235l.326-1.618a8.006,8.006,0,0,1,.4-1.528,4.381,4.381,0,0,1,3.55-2.606H113l6.4-.079,12.526-.135,23.872-.281,42.632-.506,61.146-.753,9.515-.124,3.808-.056a7.1,7.1,0,0,1,1.64.09,4.49,4.49,0,0,1,1.371.528,4.617,4.617,0,0,1,2.247,3.37A6.74,6.74,0,0,1,278.141,348.73Z",
    transform: "translate(213.271 -31.385)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_207",
    "data-name": "Ellipse 207",
    cx: 6.987,
    cy: 6.987,
    rx: 6.987,
    ry: 6.987,
    transform: "translate(393.914 365.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M225.134,349H214.046l-30.253.146-99.812.7-14.435.124H66a9.09,9.09,0,0,0-1.809.112,5.054,5.054,0,0,0-3.864,3.606c-.27,1.123-.461,2.247-.7,3.37l-5.156,26c-3.269,16.57-6.224,31.455-8.695,44.025s-4.494,22.659-5.819,29.68c-.674,3.494-1.191,6.212-1.55,8.077-.169.91-.3,1.618-.393,2.112s-.112.719-.112.719.067-.236.168-.708.258-1.191.449-2.1l1.663-8.01c1.415-7.021,3.46-17.143,6-29.646s5.5-27.444,8.819-44c1.651-8.279,3.37-16.974,5.19-25.984.236-1.123.438-2.247.685-3.37a4.493,4.493,0,0,1,1.91-2.584,4.343,4.343,0,0,1,1.517-.607,8.356,8.356,0,0,1,1.708-.1h3.539l14.435-.112,99.812-.876,30.253-.337,8.223-.225h2.865Z",
    transform: "translate(266.076 -30.654)",
    fill: "#263238"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseBg);
export default __webpack_public_path__ + "static/media/course-bg.c5a2dd92.svg";
export { ForwardRef as ReactComponent };